/**
 * Hub English core keywords + long-tail search term bank.
 * Regenerate: node scripts/build-hub-search-term-bank-en.js
 */

var CORE_KEYWORDS_EN = {
  "seedream-ai-image-generator-review": [
    "Seedream AI image generator",
    "Seedream prompts",
    "Seedream product images",
    "AI ecommerce hero images",
    "AI product image generator",
    "eBay product images",
    "Google Shopping product ads",
    "Seedream vs FLUX"
  ],
  "flux-ai-image-generator-review": [
    "FLUX AI image generator",
    "FLUX prompts",
    "FLUX product photography",
    "FLUX.2 online",
    "AI ad image generator",
    "Walmart product images",
    "Wayfair home product images",
    "Target product ad images",
    "FLUX vs Seedream"
  ],
  "midjourney-alternative-online": [
    "Midjourney alternative online",
    "Midjourney without Discord",
    "online AI art generator",
    "AI poster generator",
    "Midjourney prompts",
    "browser AI image generator"
  ],
  "gpt-image-generator-guide": [
    "GPT Image generator",
    "GPT Image prompts",
    "AI text poster generator",
    "AI product benefit images",
    "OpenAI image generator",
    "AI images with text"
  ],
  "qwen-image-generator-review": [
    "Qwen Image generator",
    "Qwen Image online",
    "Qwen Image prompts",
    "AI poster generator",
    "AI high resolution images",
    "Qwen product images"
  ],
  "z-image-ai-generator-review": [
    "Z Image Turbo",
    "Z Image AI generator",
    "fast AI image generator",
    "AI ad images",
    "AI social media images",
    "AI banner generator"
  ],
  "stable-diffusion-online-generator": [
    "Stable Diffusion online",
    "SD 3.5 online",
    "Stable Diffusion without local setup",
    "AI illustration generator",
    "Stable Diffusion prompts",
    "open source AI image generator"
  ],
  "ai-watermark-remover-online": [
    "AI watermark remover",
    "remove watermark online",
    "remove logo from image",
    "remove text from image",
    "ecommerce image cleanup",
    "Shopify product image watermark removal",
    "eBay image cleanup",
    "Etsy listing image cleanup",
    "remove watermark from photo"
  ],
  "ai-background-remover-online": [
    "free AI background remover", "free background remover online", "AI background remover", "remove image background online", "automatic background removal",
    "transparent background maker", "transparent PNG", "portrait background remover",
    "hair background removal", "background eraser"
  ],
  "ecommerce-product-background-removal": [
    "free product background remover", "free ecommerce image cutout", "product image background remover", "ecommerce product cutout", "white background product image",
    "Amazon product white background", "Shopify transparent product image",
    "eBay product background removal", "Etsy product background remover", "ecommerce hero image background"
  ],
  "ai-portrait-background-remover": [
    "free portrait background remover",
    "AI headshot background remover",
    "LinkedIn photo background removal",
    "ID photo background remover",
    "avatar background remover",
    "remove background around hair",
    "resume photo white background",
    "blue background ID photo online"
  ],
  "ai-background-changer-online": [
    "free AI background changer",
    "replace photo background online",
    "change background after cutout",
    "AI scene replacement",
    "lifestyle background changer",
    "cafe background for portrait",
    "social cover background replacement",
    "transparent PNG new background"
  ],
  "handwriting-eraser-online": [
    "AI handwriting eraser",
    "remove handwriting online free",
    "erase handwritten answers from test papers",
    "remove handwriting while preserving printed text",
    "AI test paper answer remover",
    "remove handwritten notes from documents"
  ],
  "image-crop-dewarp-online": [
    "AI document crop and dewarp",
    "document perspective correction online",
    "auto crop document photos",
    "straighten skewed document photos",
    "document edge detection",
    "fix curved book page photos"
  ],
  "kimi-k3-review": [
    "Kimi K3 review",
    "Kimi K3 coding",
    "Kimi K3 long document research",
    "Kimi K3 agent workflow",
    "how to use Kimi K3 for coding",
    "Kimi K3 vs GPT-5.6 Sol",
    "Kimi K3 open weights",
    "Kimi K3 PDF analysis"
  ],
  "claude-fable-5-review": [
    "Claude Fable 5 review",
    "Claude Fable 5 coding",
    "Claude Fable 5 agentic coding",
    "long running coding AI",
    "Claude Fable 5 document analysis",
    "Claude Fable 5 tool calling failures",
    "Claude Fable 5 vs GPT-5.6 Sol",
    "Claude Fable 5 token cost"
  ],
  "gpt-5-6-sol-review": [
    "GPT-5.6 Sol review",
    "GPT-5.6 Sol coding",
    "GPT-5.6 Sol API pricing",
    "GPT-5.6 Sol context window",
    "GPT-5.6 Sol computer use",
    "GPT-5.6 Sol agent workflows",
    "GPT-5.6 Sol vs Claude Fable 5",
    "GPT-5.6 Sol vs Kimi K3"
  ]
}

var TERM_BANK = {
  "seedream-ai-image-generator-review": [
    "Seedream 5 online image generator",
    "how to write Seedream prompts",
    "Seedream ecommerce hero images",
    "Seedream product image tutorial",
    "AI product image generator",
    "AI Instagram product posts",
    "Seedream vs FLUX",
    "Seedream vs Midjourney",
    "AI lifestyle poster generator",
    "Seedream 5 vs 4 difference",
    "best AI image generator",
    "Amazon main image AI generator",
    "how to make Amazon product images",
    "Shopify lifestyle scene images",
    "TikTok Shop product images",
    "AI white background image generator",
    "AI product detail page images",
    "how to use Seedream online",
    "AI ecommerce hero image generator",
    "AI brand poster generator",
    "AI professional headshot generator",
    "Seedream AI image generator",
    "AI image generator without Discord",
    "AI product photography prompts",
    "AI DTC store banner images",
    "Seedream product image prompts",
    "Seedream 5 review",
    "how to make product images with Seedream",
    "is Seedream free",
    "Seedream prompts",
    "AI cross-border ecommerce main images",
    "Seedream vs Dreamina",
    "how to write Seedream poster prompts",
    "AI scene image generator",
    "Seedream Amazon white background images",
    "Seedream Amazon A+ content images",
    "is Seedream good for ecommerce",
    "best AI model for product images",
    "Seedream 5 online",
    "Seedream generation speed",
    "best AI hero image generator",
    "Seedream prompt examples",
    "Seedream skincare hero images",
    "Seedream consumer electronics product images",
    "how to create lifestyle images with AI",
    "Seedream vs Stable Diffusion",
    "Seedream banner images",
    "Seedream credits pricing",
    "Seedream beginner tutorial",
    "Seedream skincare product images",
    "Seedream home lifestyle scene images",
    "Seedream food photography",
    "Seedream pet product images",
    "Seedream multi-image comparison tips",
    "Seedream background replacement",
    "Seedream 4K output",
    "Seedream vs Qwen Image",
    "AI hero image A/B testing",
    "Seedream batch image generation",
    "Seedream cross-border ecommerce banners",
    "Seedream eBay product images",
    "Seedream Etsy listing images",
    "Seedream Walmart Marketplace product images",
    "Seedream Google Shopping product ad images",
    "Seedream WooCommerce product images",
    "Seedream BigCommerce product images",
    "Seedream Squarespace banner images"
  ],
  "flux-ai-image-generator-review": [
    "FLUX.2 online image generator",
    "FLUX prompt examples",
    "FLUX product photography",
    "FLUX ad images",
    "Flux Schnell vs FLUX.2 difference",
    "FLUX vs Seedream",
    "AI commercial photography generator",
    "Flux Pro Ultra review",
    "FLUX ecommerce hero images",
    "realistic AI product images",
    "how to write FLUX product image prompts",
    "AI commercial photography prompts",
    "AI ad image prompts",
    "how to use FLUX online",
    "AI ad image generator",
    "realistic AI image generator",
    "FLUX jewelry product images",
    "FLUX watch macro photography",
    "FLUX coffee lifestyle images",
    "FLUX automotive ad style images",
    "Flux Schnell composition testing",
    "FLUX review",
    "how to make product images with FLUX",
    "is FLUX free",
    "FLUX prompts",
    "FLUX vs Midjourney",
    "FLUX skincare photography",
    "FLUX consumer electronics product images",
    "FLUX food photography",
    "FLUX online free",
    "FLUX generation speed",
    "FLUX beginner tutorial",
    "FLUX commercial ad images",
    "how to write FLUX metal reflections",
    "FLUX lifestyle images",
    "FLUX vs Stable Diffusion",
    "best AI model for product photography",
    "is Flux Pro 1.1 Ultra worth it",
    "how to use FLUX Schnell",
    "FLUX Amazon product images",
    "FLUX Shopify product images",
    "FLUX hard light product photography",
    "FLUX macro prompt tips",
    "FLUX rim light techniques",
    "FLUX delivery workflow",
    "FLUX AI image generator",
    "FLUX without installation",
    "FLUX vs Seedream comparison",
    "FLUX commercial photography tutorial",
    "FLUX home product images",
    "FLUX pet ad images",
    "FLUX outdoor product photography",
    "FLUX night product photography",
    "FLUX dual version comparison",
    "FLUX with GPT Image workflow",
    "FLUX batch composition testing",
    "FLUX 4K product images",
    "FLUX brand campaign images",
    "FLUX video cover stills",
    "FLUX product scene composites",
    "FLUX Walmart product images",
    "FLUX Target product ad images",
    "FLUX Wayfair home product images",
    "FLUX Google Shopping product ad images",
    "FLUX outdoor gear product images",
    "FLUX appliance product photography"
  ],
  "midjourney-alternative-online": [
    "Midjourney alternative online",
    "Midjourney without Discord",
    "Midjourney online generator",
    "Midjourney free alternative",
    "AI art generator like Midjourney",
    "Midjourney prompts",
    "Midjourney prompt examples",
    "best Midjourney alternative",
    "Dreamina alternative",
    "Leonardo alternative",
    "Stable Diffusion alternative",
    "AI illustration generator",
    "AI art image generator",
    "AI poster generator online",
    "AI concept art generator",
    "AI game art generator",
    "AI fantasy illustration prompts",
    "AI image generator without Discord",
    "online Midjourney alternative",
    "AI poster design tool",
    "AI social media image generator",
    "AI image generation platform",
    "Dreamina vs Midjourney",
    "Leonardo alternative online",
    "AI ecommerce hero image generator",
    "best Midjourney alternative tool",
    "how to use Midjourney online",
    "Midjourney without Discord workflow",
    "best Midjourney replacement",
    "AI concept art generation",
    "Midjourney vs Stable Diffusion",
    "Midjourney commercial image alternative",
    "Midjourney web version",
    "free Midjourney alternative",
    "Dreamina alternative online",
    "Leonardo AI alternative online",
    "AI game concept art generator",
    "online AI art images",
    "Midjourney with FLUX workflow",
    "AI posters without Discord",
    "Midjourney alternative Seedream",
    "online AI illustration generator",
    "Midjourney review",
    "Midjourney beginner guide",
    "AI style exploration tool",
    "Midjourney with GPT Image",
    "AI image generator comparison",
    "Midjourney credits",
    "Midjourney editorial illustration style",
    "Midjourney realistic portraits",
    "Midjourney brand visual exploration",
    "Midjourney packaging design style",
    "AI packaging mockup generator",
    "Midjourney interior design visuals",
    "Midjourney fashion illustration",
    "AI book cover generator",
    "Midjourney same prompt multiple styles",
    "Midjourney vs Canva AI",
    "AI creative inspiration generator"
  ],
  "gpt-image-generator-guide": [
    "GPT Image generator online",
    "GPT Image 1.5 generator",
    "GPT Image prompts",
    "OpenAI image generator online",
    "AI text poster generator",
    "AI flyer generator with text",
    "AI product mockup generator",
    "AI editable image generator",
    "AI banner with text",
    "AI typography poster",
    "AI marketing poster generator",
    "AI product explanation image",
    "AI UI mockup images",
    "GPT Image vs Midjourney",
    "GPT Image vs Seedream",
    "AI product benefit images",
    "AI social cover generator",
    "AI images with readable text",
    "OpenAI image generation",
    "AI poster prompt guide",
    "how to generate AI typography layouts",
    "GPT Image generator",
    "how to use GPT Image",
    "GPT Image English headline posters",
    "GPT Image promotional posters",
    "GPT Image vs Qwen Image",
    "AI campaign poster generator",
    "is GPT Image free",
    "GPT Image benefit image tutorial",
    "AI text poster prompts",
    "GPT Image 1.5 review",
    "OpenAI image generation online",
    "AI explainer layout images",
    "GPT Image ecommerce graphics",
    "AI flyer generator",
    "GPT Image beginner guide",
    "AI poster with headline text",
    "GPT Image with FLUX workflow",
    "AI marketing image generator",
    "GPT Image aspect ratio prompts",
    "AI product mockup images",
    "does GPT Image control text well",
    "AI poster design prompts",
    "GPT Image online free",
    "GPT Image workflow",
    "GPT Image menu design",
    "GPT Image price tag graphics",
    "GPT Image hiring poster",
    "GPT Image course promo graphics",
    "GPT Image multilingual posters",
    "GPT Image vs Canva AI",
    "GPT Image brand font posters",
    "AI explainer image generator",
    "GPT Image horizontal banner",
    "GPT Image vertical poster",
    "GPT Image holiday promo graphics",
    "GPT Image Shopify banner images",
    "GPT Image WooCommerce benefit images",
    "GPT Image Squarespace hero images",
    "GPT Image Google Shopping promo images",
    "GPT Image BigCommerce selling point images"
  ],
  "qwen-image-generator-review": [
    "Qwen Image generator online",
    "Qwen Image 2.0 Pro",
    "Qwen Image prompts",
    "Qwen Image online generation",
    "AI image generator",
    "AI poster generator",
    "AI images with text",
    "Qwen product image prompts",
    "Qwen poster prompts",
    "AI high resolution image generator",
    "AI Instagram cover generator",
    "AI newsletter header images",
    "AI marketing posters",
    "Qwen vs GPT Image",
    "Qwen vs Seedream",
    "Qwen alternative online",
    "AI course cover generator",
    "AI ecommerce detail page images",
    "product poster generator",
    "AI brand poster design",
    "high resolution AI image generator",
    "Qwen Image AI generator",
    "how to generate Qwen posters",
    "how to use Qwen Image online",
    "Qwen Image review",
    "is Qwen Image free",
    "Qwen vs GPT Image difference",
    "Qwen marketing poster tutorial",
    "Qwen product image prompt examples",
    "Qwen 2K image output",
    "Qwen Image vs FLUX",
    "AI course cover design",
    "Qwen ecommerce posters",
    "Qwen Image online generator",
    "Qwen Image beginner guide",
    "Qwen high resolution posters",
    "Qwen brand visuals",
    "AI detail page images with Qwen",
    "Qwen Image workflow",
    "Qwen vs Midjourney",
    "Qwen social media covers",
    "Qwen Image credits",
    "AI poster 2.0 Pro",
    "Qwen product showcase images",
    "Qwen Image generation tutorial",
    "Qwen holiday marketing posters",
    "Qwen Black Friday posters",
    "Qwen Cyber Monday posters",
    "Qwen product launch posters",
    "Qwen live stream preview covers",
    "Qwen brand collaboration posters",
    "Qwen horizontal banners",
    "Qwen vertical key visuals",
    "Qwen vs Dreamina",
    "Qwen multi-size export",
    "Qwen poster A/B testing",
    "Qwen Shopify product launch images",
    "Qwen Squarespace brand banners",
    "Qwen Etsy listing covers",
    "Qwen WooCommerce brand posters",
    "Qwen BigCommerce campaign visuals"
  ],
  "z-image-ai-generator-review": [
    "Z Image AI generator",
    "Z Image Turbo online",
    "Z Image prompt examples",
    "Z Image prompts",
    "fast AI image generator",
    "AI ad image generator",
    "AI social media image generator",
    "AI creative image generator",
    "AI poster draft generator",
    "AI Facebook ad images",
    "AI Instagram post generator",
    "AI TikTok product images",
    "AI YouTube thumbnail draft",
    "AI banner generator online",
    "AI ecommerce banner generator",
    "AI campaign poster generator",
    "AI promo image generator",
    "Z Image vs FLUX",
    "Z Image vs Seedream",
    "fast AI image tool",
    "AI ad creative drafts",
    "AI social media covers",
    "how to generate AI promo posters",
    "Z Image Turbo online generator",
    "Z Image review",
    "is Z Image free",
    "Z Image vs Flux Schnell",
    "Z Image ad concept drafts",
    "Z Image promo banner images",
    "Z Image beginner tutorial",
    "Z Image generation speed",
    "Z Image ecommerce images",
    "Z Image with GPT Image",
    "AI creative sketch tool",
    "Z Image Turbo prompts",
    "Z Image workflow",
    "AI social ad images",
    "Z Image direction testing",
    "Z Image final draft with FLUX",
    "best fast AI image generator",
    "Z Image campaign images",
    "Z Image with Seedream workflow",
    "AI YouTube thumbnail sketch",
    "Z Image credits",
    "how to use Z Image online",
    "Z Image Black Friday promo images",
    "Z Image product teaser images",
    "Z Image live stream cover sketch",
    "Z Image limited-time discount banners",
    "Z Image brand collab sketches",
    "Z Image multi-size drafts",
    "Z Image vs Midjourney",
    "Z Image low-cost iteration",
    "Z Image multi-version testing tips",
    "Z Image color palette drafts",
    "Z Image holiday campaign images",
    "Z Image Google Shopping ad drafts",
    "Z Image eBay promo images",
    "Z Image Walmart campaign banners",
    "Z Image Meta ad images",
    "Z Image Target promo drafts"
  ],
  "stable-diffusion-online-generator": [
    "Stable Diffusion online",
    "Stable Diffusion 3.5 online",
    "SD 3.5 generator",
    "Stable Diffusion without installation",
    "online Stable Diffusion generator",
    "Stable Diffusion prompt examples",
    "Stable Diffusion prompts",
    "Stable Diffusion alternative online",
    "AI illustration generator",
    "AI anime image generator",
    "AI concept art generator",
    "AI character design generator",
    "AI game asset generator",
    "Stable Diffusion without local deployment",
    "online SD image generator",
    "Stable Diffusion web generator",
    "Stable Diffusion vs Midjourney",
    "Stable Diffusion vs FLUX",
    "open source AI image generator",
    "AI illustration prompts",
    "AI character design sheets",
    "AI stylized avatar generator",
    "SD illustration prompts",
    "AI game concept art",
    "Stable Diffusion no install",
    "ComfyUI alternative online",
    "AI illustration generation",
    "open source AI image generation",
    "how to use SD 3.5 online",
    "SD vs Midjourney which is better",
    "Stable Diffusion beginner tutorial",
    "is Stable Diffusion free",
    "SD character design prompts",
    "SD anime style prompts",
    "SD concept art tutorial",
    "Stable Diffusion online free",
    "SD vs FLUX",
    "online SD illustration generator",
    "Stable Diffusion review",
    "Stable Diffusion without GPU",
    "SD game asset generation",
    "SD style control",
    "SD with Seedream workflow",
    "AI anime generator",
    "SD 3.5 review",
    "Stable Diffusion web version",
    "SD workflow online",
    "SD editorial illustration style",
    "SD sci-fi scene generator",
    "SD pixel art generator",
    "SD watercolor illustration",
    "SD character turnaround sheets",
    "SD emoji generator",
    "SD wallpaper generator",
    "SD vs Midjourney same prompt comparison",
    "SD batch style testing",
    "SD line art coloring",
    "SD picture book illustration"
  ],
  "ai-watermark-remover-online": [
    "AI watermark remover online",
    "remove watermark from image",
    "remove watermark from photo online",
    "remove logo from image",
    "AI remove text from image",
    "online watermark eraser",
    "photo watermark remover",
    "remove transparent watermark",
    "remove repeated watermark",
    "remove product image watermark",
    "remove poster watermark",
    "remove TikTok screenshot watermark",
    "AI watermark removal tool",
    "remove photo text watermark",
    "remove product listing watermark",
    "remove poster overlay marks",
    "remove image stamps",
    "AI image cleanup tool",
    "ecommerce image watermark removal",
    "remove watermark without traces",
    "remove text from image",
    "AI image cleanup workflow",
    "how to use AI watermark remover",
    "is watermark remover free",
    "does watermark removal hurt quality",
    "product image watermark removal tutorial",
    "social screenshot watermark removal",
    "how to remove transparent watermarks",
    "repeated watermark removal",
    "poster watermark cleanup",
    "watermark remover vs Photoshop",
    "watermark removal for commercial use",
    "AI image mark cleanup",
    "watermark remover beginner guide",
    "online image stamp removal",
    "watermark erase tool",
    "watermark removal steps",
    "Miral watermark remover",
    "is watermark removal safe",
    "batch watermark removal",
    "corner logo removal",
    "AI background inpainting",
    "remove video screenshot watermark",
    "remove PDF to image watermark",
    "remove ID photo watermark",
    "remove mockup watermark",
    "remove stock image marks",
    "remove platform download watermark",
    "color grade after watermark removal",
    "watermark removal then FLUX workflow",
    "small image watermark removal tips",
    "large watermark removal",
    "watermark removal failed what to do",
    "Shopify product image watermark removal",
    "Shopify supplier image logo removal",
    "eBay image cleanup",
    "Etsy listing image cleanup",
    "Walmart Marketplace image logo removal",
    "Google Shopping product image cleanup",
    "cross-border ecommerce image watermark removal"
  ],
  "ai-background-remover-online": [
    "free AI background remover", "free background remover online", "AI background remover online", "remove image background online", "automatic background removal",
    "transparent background maker", "make image background transparent", "download transparent PNG",
    "remove background from JPG", "remove background from PNG", "remove background from WebP",
    "portrait background remover", "person background remover", "hair background removal",
    "profile picture background remover", "logo background remover", "signature background remover",
    "ID photo background remover", "pet photo background remover", "product photo background remover",
    "how to remove an image background online", "how to make a photo background transparent",
    "how to export a transparent PNG", "convert JPG to transparent PNG", "remove photo background on phone",
    "remove background without Photoshop", "preserve image size after background removal",
    "does background removal reduce image quality", "fix white edges after background removal",
    "fix background removal halo", "remove background around hair", "transparent object background removal",
    "glass object background remover", "complex background remover", "remove white background from white object",
    "remove dark background from black object", "prepare photo for background replacement",
    "transparent profile picture", "remove background for poster assets", "transparent ecommerce asset",
    "online transparent background tool", "free automatic image cutout", "JPG PNG WebP background remover",
    "remove background from 15 MB image", "Miral background remover", "background eraser online",
    "AI photo cutout", "automatic subject detection", "remove full image background", "photo to transparent PNG"
  ],
  "ecommerce-product-background-removal": [
    "free product background remover", "free ecommerce image cutout", "product image background remover", "ecommerce product cutout", "white background product image",
    "transparent product PNG", "Amazon product white background", "Amazon main image background removal",
    "Shopify transparent product image", "Shopify product background remover", "eBay product background removal",
    "Etsy product background remover", "Google Shopping product background", "cross-border ecommerce product images",
    "AI product cutout", "automatic product background removal", "clothing background remover",
    "shoe product cutout", "jewelry background removal", "transparent jewelry product image",
    "glass product background removal", "clear packaging background remover", "fur product cutout",
    "furniture product background removal", "beauty product white background", "electronics product white background",
    "how to make an Amazon white background image", "how to remove a product image background",
    "do Shopify product images need white backgrounds", "transparent vs white product background",
    "change product background to white", "standardize product image backgrounds", "ecommerce hero image background",
    "transparent assets for product detail pages", "independent store product background removal",
    "preserve product edges during background removal", "fix white halo around product cutout",
    "replace product background after cutout", "create lifestyle image from product cutout",
    "Amazon Shopify product image workflow", "eBay Etsy product image optimization",
    "cross-border ecommerce image tool", "product catalog background removal", "product photography background removal",
    "AI ecommerce white background tool", "marketplace product image cutout", "product image transparent background",
    "prepare product photos for online store", "remove background from reflective product", "remove background from glass product"
  ],
  "ai-portrait-background-remover": [
    "free portrait background remover", "AI headshot background remover", "LinkedIn photo background removal",
    "ID photo background remover", "avatar background remover", "remove background around hair",
    "resume photo white background", "blue background ID photo online", "WeChat avatar transparent background",
    "Instagram profile picture cutout", "passport photo background preparation", "visa photo background remover",
    "professional headshot background removal", "office selfie to LinkedIn photo", "glasses portrait cutout",
    "curly hair background removal", "kids portrait background remover", "transparent portrait PNG",
    "how to remove portrait background online", "how to make a white resume photo", "how to make a blue ID photo",
    "fix white halo on face cutout", "phone selfie background remover", "Miral portrait background remover",
    "head and shoulders background removal", "recruitment website profile photo", "certificate photo background change",
    "how to make a LinkedIn headshot with background removal", "what tool can I use for hair cutout on portraits",
    "what tool can I use to prepare a passport photo background", "how to fix a white halo after portrait background removal",
    "gray background professional headshot", "suit headshot background removal", "Xiaohongshu profile picture cutout",
    "can I remove a WeChat avatar background for free", "transparent vs white ID photo background"
  ],
  "ai-background-changer-online": [
    "free AI background changer", "replace photo background online", "change background after cutout",
    "AI scene replacement", "lifestyle background changer", "cafe background for portrait",
    "social cover background replacement", "transparent PNG new background", "office background replacement",
    "brand color background composite", "event poster background change", "outdoor daylight background swap",
    "AI generated scene behind person", "how to change photo background online", "how to put selfie in cafe scene",
    "fix fake looking background composite", "difference between remove and change background",
    "Seedream lifestyle scene background", "FLUX.2 background scene replacement", "video cover background change",
    "Miral AI background changer", "not for Amazon white background", "transparent subject new environment",
    "how to change a social cover background after cutout", "can I replace a selfie background with a cafe scene",
    "what tool can I use for event poster background replacement", "what tool can I use for social cover background replacement",
    "how to fix outdoor daylight mismatch when changing backgrounds", "course cover background change",
    "talk announcement background change", "Instagram banner background change",
    "can I generate an AI scene behind a real person", "remove vs change background which to use"
  ],
  "handwriting-eraser-online": [
    "Handwriting Eraser online",
    "AI handwriting remover",
    "remove handwriting from image",
    "remove handwritten text from scanned document",
    "erase handwriting from photo",
    "AI remove pen marks",
    "remove annotations from document",
    "remove handwriting from PDF image",
    "remove red pen marks",
    "remove notes from scanned paper",
    "clean scanned document online",
    "AI handwritten text remover",
    "remove handwriting online for free",
    "remove handwritten answers from test papers",
    "remove handwriting while preserving printed text",
    "remove handwritten marks from scanned documents",
    "erase handwriting on scanned docs",
    "remove handwriting from contracts",
    "erase handwritten notes",
    "auto rotate scanned documents",
    "how to erase handwritten notes",
    "can AI erase handwriting without removing printed text",
    "what tool can I use to remove handwritten answers from test papers",
    "how to fix blurred text when removing handwriting",
    "remove handwriting from JPG PNG WebP",
    "AI test paper answer remover",
    "remove test paper answers online for free",
    "restore a test paper to a blank copy",
    "remove student answers from test papers",
    "remove handwriting from student homework",
    "remove handwritten answers from workbooks",
    "remove handwritten answers while preserving questions",
    "test paper answer remover for teachers",
    "test paper cleaner for students",
    "restore answered test papers for review",
    "remove handwritten annotations from test papers",
    "remove red pen corrections from test papers",
    "remove pencil writing from test papers",
    "remove pen writing from test papers",
    "blank test paper generator from answered sheets",
    "erase answers from worksheets",
    "reset test papers for student revision",
    "remove handwriting from scanned test papers",
    "remove pen marks from document",
    "AI document cleanup workflow",
    "how to use handwriting eraser",
    "is handwriting eraser free",
    "PDF scan handwriting removal",
    "how to erase red pen annotations",
    "contract handwriting cleanup",
    "remove note doodles",
    "will handwriting eraser delete printed text",
    "table photo handwriting removal tutorial",
    "document annotation cleanup steps",
    "scanned document cleanup workflow",
    "handwriting eraser and dewarp order",
    "AI pen mark removal",
    "handwriting trace removal",
    "Miral handwriting eraser",
    "print after handwriting removal",
    "is handwriting eraser safe",
    "multi-page scan handwriting removal",
    "handwriting eraser beginner guide",
    "can pencil writing be erased",
    "blue pen mark removal",
    "handwriting eraser results",
    "document digitization cleanup",
    "remove highlighter marks",
    "remove signatures from scans",
    "remove handwritten dates",
    "remove header annotations",
    "multi-column document handwriting removal",
    "landscape scan handwriting removal",
    "compress PDF after erasure",
    "handwriting removal before OCR",
    "historical document restoration",
    "old scan handwriting removal",
    "handwriting eraser retry tips"
  ],
  "image-crop-dewarp-online": [
    "Image Crop and Dewarp online",
    "document dewarp online",
    "fix skewed document photo",
    "straighten scanned document",
    "deskew scanned documents online",
    "crop document photo online",
    "auto crop receipt photo",
    "auto crop scanned document images",
    "dewarp book page",
    "fix curved document image",
    "document perspective correction",
    "whiteboard photo correction",
    "scan photo dewarp",
    "AI document crop and correction",
    "correct documents online for free",
    "crop document images online",
    "automatic document edge detection",
    "scan document shadow removal and text sharpening",
    "straighten document photos online",
    "fix tilted scanned documents",
    "book page curve correction",
    "document black and white scan effect",
    "whiteboard OCR preprocessing",
    "crop then handwriting eraser order",
    "AI document enhancement workflow",
    "how to straighten phone photos of contracts",
    "receipt photo correction",
    "ID photo perspective correction",
    "severely curved book page two-pass correction",
    "document correction before OCR",
    "how to straighten phone whiteboard photos",
    "free online document correction trial",
    "auto crop document background",
    "document photo deskew online",
    "fix document perspective distortion",
    "scan shadow removal online",
    "document text sharpening",
    "contract photo straightening",
    "certificate photo correction",
    "notebook page dewarp",
    "exam paper photo correction",
    "invoice photo crop and straighten",
    "document archive preprocessing",
    "mobile document scanner alternative",
    "fix trapezoid document photos",
    "remove desk background from document photos",
    "document photo enhancement for OCR",
    "batch document photo correction",
    "fix rotated scan pages",
    "document border auto trim",
    "perspective fix for legal documents",
    "fix wrinkled paper scans",
    "document photo cleanup workflow",
    "scan quality improvement online",
    "document photo glare reduction",
    "fix uneven lighting on document photos",
    "prepare document photos for printing",
    "how to auto crop scanned document images",
    "can I deskew a scanned document online",
    "what tool can I use to straighten document photos before OCR",
    "how to fix perspective distortion when correcting document photos",
    "document photo correction before handwriting removal",
    "Miral document crop and dewarp"
  ],
  "kimi-k3-review": [
    "Kimi K3 review",
    "how to use Kimi K3 for coding",
    "how to use Kimi K3 for long-context research",
    "Kimi K3 long document analysis",
    "Kimi K3 agent workflow",
    "Kimi K3 PDF research",
    "Kimi K3 vs GPT-5.6 Sol for coding",
    "Kimi K3 open weights",
    "Kimi K3 losing context fix",
    "Kimi K3 image understanding",
    "Kimi K3 Vue React refactoring",
    "best AI for long document research",
    "can Kimi K3 analyze PDFs",
    "Kimi K3 code scaffolding",
    "Kimi K3 multimodal debugging",
    "Kimi K3 self hosting requirements",
    "Kimi K3 reasoning effort",
    "Kimi K3 model ID",
    "Kimi K3 1M context window"
  ],
  "claude-fable-5-review": [
    "Claude Fable 5 review",
    "Claude Fable 5 coding",
    "Claude Fable 5 agentic coding",
    "Claude Fable 5 long running tasks",
    "Claude Fable 5 document analysis",
    "Claude Fable 5 tool calling failures",
    "Claude Fable 5 token cost",
    "Claude Fable 5 vs GPT-5.6 Sol coding",
    "Claude Fable 5 knowledge work",
    "Claude Fable 5 stage summaries",
    "best AI for multi-step coding",
    "Claude Fable 5 PDF charts analysis",
    "how to fix Claude tool calling errors",
    "Claude Fable 5 reduce token usage",
    "long context coding AI review",
    "Claude Fable 5 vs Mythos 5",
    "Claude Fable 5 Opus 4.8 fallback",
    "Claude Fable 5 model ID",
    "Claude Fable 5 safety routing"
  ],
  "gpt-5-6-sol-review": [
    "GPT-5.6 Sol review",
    "what is GPT-5.6 Sol",
    "GPT-5.6 Sol model ID",
    "GPT-5.6 Sol 1.05M context window",
    "GPT-5.6 Sol 128K output",
    "GPT-5.6 Sol API pricing",
    "GPT-5.6 Sol long context pricing",
    "GPT-5.6 Sol coding review",
    "GPT-5.6 Sol computer use",
    "GPT-5.6 Sol tool calling",
    "GPT-5.6 Sol agent workflows",
    "GPT-5.6 Sol reasoning effort",
    "GPT-5.6 Sol vs Terra vs Luna",
    "GPT-5.6 Sol vs Claude Fable 5",
    "GPT-5.6 Sol vs Kimi K3",
    "GPT-5.6 Sol professional research",
    "GPT-5.6 Sol Responses API"
  ]
}

// Curated question-style variants. These follow natural search phrasing instead
// of mechanically converting every noun phrase into all four templates.
var QUESTION_TERM_BANK = {
  'seedream-ai-image-generator-review': [
    'can I use Seedream for Amazon main images',
    'what AI tool can I use to create ecommerce hero images',
    'how to create ecommerce product images with Seedream',
    'how to fix inaccurate product details when generating Seedream images',
    'is it possible to make Shopify lifestyle images with Seedream',
    'what tool can I use for Google Shopping product ads',
    'how to create Amazon main images with Seedream 5'
  ],
  'flux-ai-image-generator-review': [
    'can I use FLUX for commercial product images',
    'what AI tool can I use to create hard light product photos',
    'how to create product photography with FLUX',
    'how to fix soft material details and reflections when generating FLUX images',
    'is it possible to generate realistic jewelry photos with FLUX'
  ],
  'midjourney-alternative-online': [
    'can I use Midjourney in a browser',
    'what tool can I use to create ecommerce images without Discord',
    'how to use Midjourney online without Discord',
    'how to fix the wrong art style when using a Midjourney alternative',
    'is it possible to create Midjourney style art without Discord'
  ],
  'gpt-image-generator-guide': [
    'can I use GPT Image for Shopify banners',
    'what AI tool can I use to create product benefit graphics',
    'how to create text posters with GPT Image',
    'how to fix misspelled text when creating GPT Image posters',
    'is it possible to generate readable text in AI images'
  ],
  'qwen-image-generator-review': [
    'can I use Qwen Image for ecommerce detail pages',
    'what AI tool can I use to create large campaign posters',
    'how to create high resolution posters with Qwen Image',
    'how to fix unreadable text when generating Qwen Image posters',
    'is it possible to generate 2K marketing images with Qwen'
  ],
  'z-image-ai-generator-review': [
    'can I use Z Image Turbo for social media ads',
    'what AI tool can I use to test ad compositions quickly',
    'how to create fast ad concepts with Z Image Turbo',
    'how to fix weak product details when creating Z Image drafts',
    'is it possible to generate campaign drafts with Z Image'
  ],
  'stable-diffusion-online-generator': [
    'can I use Stable Diffusion without a local GPU',
    'what AI tool can I use to create illustrations without ComfyUI',
    'how to use Stable Diffusion online without installation',
    'how to fix inconsistent character details when generating Stable Diffusion images',
    'is it possible to run SD 3.5 in a browser'
  ],
  'ai-watermark-remover-online': [
    'can I remove a logo from a product photo online',
    'what tool can I use to remove corner marks from Shopify images',
    'how to remove watermarks from ecommerce images online',
    'how to fix repeated textures when removing a watermark',
    'is it possible to erase transparent watermarks from images',
    'how to remove a watermark from an ecommerce image',
    'how to fix blurry edges after watermark removal'
  ],
  'ai-background-remover-online': [
    'can I remove an image background online without Photoshop',
    'what AI tool can I use to make a transparent PNG',
    'how to remove a photo background automatically',
    'how to fix white edges after AI background removal',
    'is it possible to remove a background around hair online',
    'how to remove a background from JPG PNG or WebP',
    'does AI background removal preserve image quality'
  ],
  'ecommerce-product-background-removal': [
    'can I make an Amazon white background product image online',
    'what tool can I use to create transparent Shopify product images',
    'how to remove backgrounds from ecommerce product photos',
    'how to fix missing glass edges in a product cutout',
    'is it possible to reuse one transparent PNG across marketplaces',
    'how to prepare product images for eBay and Etsy',
    'what is the difference between a transparent and white product background'
  ],
  'ai-portrait-background-remover': [
    'can I remove a portrait background online for free',
    'what AI tool can I use for LinkedIn headshot background removal',
    'how to make a white or blue ID photo from a selfie',
    'how to keep hair details when removing a portrait background',
    'is it possible to cut out a photo with glasses online',
    'how to prepare a passport photo background online',
    'what is the difference between transparent and white portrait backgrounds',
    'how to make a LinkedIn headshot with background removal',
    'what tool can I use for hair cutout on portraits',
    'what tool can I use to prepare a passport photo background',
    'how to fix a white halo after portrait background removal',
    'can I remove a WeChat avatar background for free'
  ],
  'ai-background-changer-online': [
    'can I change a photo background online for free',
    'what tool can I use to replace a selfie background with a cafe scene',
    'how to change background after AI cutout',
    'how to fix a fake looking background composite',
    'is it possible to generate a new AI scene behind a real person',
    'how to make a lifestyle cover from a transparent PNG',
    'what is the difference between background removal and background changing',
    'how to change a social cover background after cutout',
    'can I replace a selfie background with a cafe scene',
    'what tool can I use for event poster background replacement',
    'what tool can I use for social cover background replacement',
    'how to fix outdoor daylight mismatch when changing backgrounds'
  ],
  'handwriting-eraser-online': [
    'can I remove handwriting without deleting printed text',
    'what tool can I use to clean handwritten marks from worksheets',
    'how to erase handwriting from scanned documents online',
    'how to fix broken printed lines when removing handwriting',
    'is it possible to erase answers from a test paper online',
    'how to erase handwritten notes from scanned documents',
    'how to fix blurred text when removing handwriting'
  ],
  'image-crop-dewarp-online': [
    'can I straighten a document photo online',
    'what tool can I use to fix document perspective before OCR',
    'how to auto crop and deskew scanned documents',
    'how to fix hidden page edges when auto cropping documents',
    'is it possible to dewarp a curved book page in a browser'
  ],
  'kimi-k3-review': [
    'can I use Kimi K3 to analyze long documents',
    'how to use Kimi K3 for coding',
    'how to fix Kimi K3 losing context',
    'is it possible to build AI agents with Kimi K3',
    'how to use Kimi K3 for PDF competitor research',
    'is Kimi K3 suitable for self hosting',
    'can Kimi K3 debug code from a screenshot',
    'Kimi K3 vs GPT-5.6 Sol which is better for coding',
    'how to use Kimi K3 to cross-check long reports',
    'how to use Kimi K3 for a large repository refactor',
    'how to debug code with Kimi K3 and a screenshot'
  ],
  'claude-fable-5-review': [
    'can I use Claude Fable 5 for agentic coding',
    'how to use Claude Fable 5 for long-running coding',
    'how to fix Claude Fable 5 tool-calling failures',
    'how to reduce Claude Fable 5 token costs',
    'can I use Claude Fable 5 to analyze complex documents',
    'why did Claude Fable 5 fall back to Opus 4.8',
    'what is the difference between Claude Fable 5 and Mythos 5',
    'Claude Fable 5 vs GPT-5.6 Sol which is better for coding',
    'how to use Claude Fable 5 for a cross-file migration',
    'can Claude Fable 5 review complex documents'
  ],
  'gpt-5-6-sol-review': [
    'what is GPT-5.6 Sol',
    'how to use GPT-5.6 Sol for coding',
    'can I use GPT-5.6 Sol for computer use tasks',
    'how much does GPT-5.6 Sol cost per million tokens',
    'how to reduce GPT-5.6 Sol long context cost',
    'is GPT-5.6 Sol better than Terra or Luna',
    'can GPT-5.6 Sol build multi-tool agents',
    'GPT-5.6 Sol vs Claude Fable 5 for coding',
    'GPT-5.6 Sol vs Kimi K3 for long context',
    'how to use GPT-5.6 Sol for a multi-service migration',
    'can GPT-5.6 Sol cross-check several research reports',
    'how to use GPT-5.6 Sol for computer use tasks',
    'how to control GPT-5.6 Sol long-context cost',
    'how to build a multi-tool agent with GPT-5.6 Sol'
  ]
}

Object.keys(QUESTION_TERM_BANK).forEach(function (slug) {
  QUESTION_TERM_BANK[slug].forEach(function (term) {
    if (TERM_BANK[slug].indexOf(term) < 0) TERM_BANK[slug].push(term)
  })
})

module.exports = {
  CORE_KEYWORDS_EN: CORE_KEYWORDS_EN,
  TERM_BANK: TERM_BANK,
  QUESTION_TERM_BANK: QUESTION_TERM_BANK
}
